import { useEffect, useState } from "react";

// Flips to true once `loading` has stayed true for `ms`, so a request that hangs
// (resolves to neither data nor error) surfaces the builder error state instead of
// an endless skeleton (PAD-31535). Resets whenever loading clears.
export const useLoadTimeout = (loading: boolean, ms = 30000): boolean => {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!loading) {
      setTimedOut(false);
      return;
    }
    const timer = setTimeout(() => setTimedOut(true), ms);
    return () => clearTimeout(timer);
  }, [loading, ms]);

  return timedOut;
};
